export default __webpack_public_path__ + "static/generative_ai_banner-b0ce334c057e0275b195984d4b97d7a9.webp";